module.exports = __webpack_public_path__ + "media/src/images/facebookLoginBtn-56f019983326465b4b322baead818b5c.png";